// The QR spec requires a quiet zone of at least 4 modules, but
// react-qrcode-logo takes quietZone in *pixels* and defaults it to 10 — a
// margin that shrinks in module terms as the encoded payload grows. At the
// registration URL (~94 chars, version 5) that worked out to 2.9 modules, and
// phones stopped reading the codes.
//
// A QR is at least 21 modules across, so a module is at most size/21 px and 4
// of them at most 4*size/21 ~= 0.19*size. A fifth of the size clears that for
// every version, and extra white margin costs nothing.
export const qrQuietZone = (size) => Math.ceil(size / 5)
